import { render } from "./LocationInfo.vue?vue&type=template&id=0800984e"
import script from "./LocationInfo.vue?vue&type=script&lang=js"
export * from "./LocationInfo.vue?vue&type=script&lang=js"

import "./LocationInfo.vue?vue&type=style&index=0&id=0800984e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__